













































import { Component, Prop } from 'vue-property-decorator'
import SolicitacaoCirurgiaStore from '@/components/SolicitacaoCirurgia/store/SolicitacaoCirurgiaStore'
import Vue from 'vue'
import { getModule } from 'vuex-module-decorators'

@Component
export default class ModalIgnoreReservation extends Vue {
  @Prop({ type: Boolean, required: true }) readonly visible!: boolean
  @Prop({ type: Boolean, required: true })
  readonly canIgnoreReservation!: boolean

  get getSolicitacaoCirurgiaStore() {
    return getModule(SolicitacaoCirurgiaStore, this.$store)
  }

  closeModal() {
    this.$emit('close')
  }

  editReservation() {
    this.$emit('editReservation')
  }

  ignoreReservation() {
    this.$emit('ignoreReservation')
  }
}
